import { Link as RouterLink } from '@tanstack/react-router'
import type { ComponentProps, ReactNode } from 'react'

type Props = Omit<ComponentProps<'a'>, 'href'> & { href: string; children?: ReactNode; prefetch?: boolean; replace?: boolean }

/**
 * `next/link` as the ported components expect it: `href` instead of `to`.
 * Hash and absolute links fall back to a plain anchor.
 */
export default function Link({ href, prefetch: _prefetch, replace, children, ...rest }: Props) {
  if (/^(https?:|mailto:|#)/.test(href)) {
    return (
      <a href={href} {...rest}>
        {children}
      </a>
    )
  }
  return (
    <RouterLink to={href as never} replace={replace} {...(rest as object)}>
      {children}
    </RouterLink>
  )
}
